export { VIcon } from "./VIcon.mjs";
export { VComponentIcon, VSvgIcon, VLigatureIcon, VClassIcon } from "../../composables/icons.mjs";
//# sourceMappingURL=index.mjs.map